import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

import QueriesItem from './QueriesItem.vue'


import {PropType} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'QueriesList',
  props: {
  queries: Array as PropType<string[]>,
  canRemove: {
    type: Boolean as PropType<boolean>,
    default: false
  }
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_TransitionGroup, {
    class: "onfocus__queries-list q-list-group q-list-group-flush q-w-100 q-px-2",
    name: "list",
    tag: "ul"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.queries, (query, index) => {
        return (_openBlock(), _createBlock(QueriesItem, {
          key: query,
          "query-item": query,
          index: index,
          "can-remove": __props.canRemove
        }, null, 8, ["query-item", "index", "can-remove"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})